// @generated
import { galleries } from './galleries';

export const stashGallections = galleries.map(g => ({
  ...g,
  type: 'stash',
  parentId: null,
}));
